module.exports = {
  api_endpoint: 'https://tempd.link',
  file_endpoint: 'https://tempd.link'
};



/** WEBPACK FOOTER **
 ** ./config/app.js
 **/